import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faDownload } from '@fortawesome/pro-light-svg-icons';
import { ExportTemplateButtonComponent } from './export-template-button.component';

@NgModule({
  declarations: [ExportTemplateButtonComponent],
  imports: [FontAwesomeModule, MatButtonModule],
  exports: [ExportTemplateButtonComponent],
})
export class ExportTemplateModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faDownload);
  }
}
